<template>
    <v-dialog v-model="dialog" max-width="600px" scrollable content-class="z-full-width-dialog">
        <v-card>
            <v-card-title class="headline flex-column pa-2">
                <div class="d-flex fill-width">
                    <div class="flex-grow-1">{{$translate('Change image')}}</div>
                    <v-btn icon @click="dialog = false" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4">
                        <teamsport-team-logo :upper-color="newTeam.shirtColor" :lower-color="newTeam.shortsColor" :name="newTeam.shortName" @image-created="newTeam.image = $event" />
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-form @submit.prevent="submit" v-model="newTeamDone">
                            <form-field v-for="field in newTeamFields" :field="field" :key="field.name" v-model="newTeam[field.name]" star />
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="saving" :disabled="!newTeamDone">{{$translate('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const colors = [
    {value: '#F8F8F8', text: 'White'},
    {value: '#000000', text: 'Black'},
    {value: '#ff0000', text: 'Red'},
    {value: '#00ff00', text: 'Green'},
    {value: '#0000ff', text: 'Blue'},
    {value: '#ffff00', text: 'Yellow'},
    {value: '#ff00ff', text: 'Purple'},
    {value: '#00ffff', text: 'Cyan'},
    {value: '#ff8000', text: 'Orange'}
];

import FormField from '../components/FormField.vue'
import TeamsportTeamLogo from '../components/TeamsportTeamLogo.vue'
export default {
    name: 'zoezi-teamsport-team-logo-form',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        group: {
            type: Object
        }
    },

    components: {
        FormField,
        TeamsportTeamLogo
    },

    data: () => ({
        newTeamDone: false,
        newTeam: {
            shortName: '',
            shirtColor: null,
            shortsColor: null,
            image: null
        },
        newTeamFields: [
            {name: 'shortName', type: 'text', title: 'Abbreviation (max 4 characters)', max: 4, required: true},
            {name: 'shirtColor', type: 'color', title: 'Team color upper half', required: true, colors},
            {name: 'shortsColor', type: 'color', title: 'Team color lower half', required: true, colors}
        ],
        saving: false
    }),

    watch: {
        dialog: {
            immediate: true,
            handler() {
                if (this.dialog) {
                    this.extractSpecificColorsFromImageUrl(this.$api.getImageUrl(this.group.imagekey, 400))
                }
            }
        }
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },

    methods: {
        save() {
            this.saving = true;
            this.$api.post('/api/memberapi/usergroup/change', {id: this.group.id, image: this.newTeam.image}).then(() => {
                this.dialog = false;
                this.saving = false;
            });
        },
        rgbToHex(r, g, b) {
            // Konvertera varje färgkomponent till HEX och returnera den sammansatta strängen
            return "#" + [r, g, b].map(x => {
                const hex = x.toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            }).join('');
        },
        extractSpecificColorsFromImageUrl(imageUrl) {
            // Skapa en ny bild
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = imageUrl;

            const upperPoint = {x: 100, y: 50};
            const lowerPoint = {x: 100, y: 150};

            img.onload = () => {
                // Skapa en canvas och rita bilden på den
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d', {willReadFrequently: true});
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                // Läs av färgen på de angivna punkterna
                const upperColorData = ctx.getImageData(upperPoint.x, upperPoint.y, 1, 1).data;
                const lowerColorData = ctx.getImageData(lowerPoint.x, lowerPoint.y, 1, 1).data;

                // Konvertera RGB till strängformat
                const upperColor = this.rgbToHex(upperColorData[0], upperColorData[1], upperColorData[2]);
                const lowerColor = this.rgbToHex(lowerColorData[0], lowerColorData[1], lowerColorData[2]);

                this.newTeam.shirtColor = upperColor;
                this.newTeam.shortsColor = lowerColor;
            };
        }
    }
}
</script>
